import React, { useState, Context, ReactElement, Component } from "react";

export interface left_menu_item {
    [key: string]: string;
}

export const menu_items: left_menu_item[][] = [
    // Workspace
    [
        { key: 'workspaces' }
    ],

    // Workspace-overview
    [
        { key: 'overview' },
        { key: 'namespaces' }
    ],

    // Namespace-overview
    [
        { key: 'overview' },
        { key: 'workloads' }
    ],

    //quotas
    [
        { key: 'workspace-quotas' },
        { key: 'namespace-quotas' }
    ],

    // storage
    [
        // { key: 'storage-classes' }
        { key: 'storage' },
        { key: 'pvc' },
        { key: 'pv' }
    ],

    //security
    [
        { key: 'roles' }
    ],
    [
        { key: 'clusterAdmin' },
        { key: 'admin' }
    ],
    [
        { key: 'overview' },
        { key: 'workspaces' }
    ]
];

const LeftMenuContext: Context<[left_menu_item[], React.Dispatch<React.SetStateAction<left_menu_item[]>>]> = React.createContext<[left_menu_item[], React.Dispatch<React.SetStateAction<left_menu_item[]>>]>([[] as unknown as left_menu_item[], (_value: any) => { }]);

const LeftMenuProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [left_menu_items, set_left_menu_items] = useState([] as unknown as left_menu_item[]);
    return (
        <LeftMenuContext.Provider value={[left_menu_items, set_left_menu_items]}>
            {props.children}
        </LeftMenuContext.Provider>
    )
}

export { LeftMenuContext, LeftMenuProvider };